export const asset = (state) => state.assetDetails;